// extracted by mini-css-extract-plugin
export default {"text":"GradientText-module--text--Ayi8+"};